/** Non-secret operation receipts have their own lifetime, independent of page initialization. */
export const RECOVERY_STORAGE_PREFIX = 'sfRecovery:';
